import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("  Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_slot_error = _resolveComponent("slot-error")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.showModalUpdateTracking,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showModalUpdateTracking) = $event)),
    title: "Update Tracking",
    top: "6vh",
    width: "80%"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSaveTracking()))
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives(_createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_table, {
            data: _ctx.state.items,
            fit: "",
            lazy: "",
            stripe: "",
            "max-height": "600"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "selection",
                "min-width": 3
              }),
              _createVNode(_component_el_table_column, {
                prop: "imageSrc",
                label: "Mockup",
                "min-width": 10
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_image, {
                    style: {"width":"80px","height":"80px"},
                    fit: "cover",
                    src: _ctx.imageUrl(scope.row.imageSrc, true, 200),
                    "preview-src-list": [_ctx.imageUrl(scope.row.imageSrc)],
                    "min-width": 10
                  }, {
                    error: _withCtx(() => [
                      _createVNode(_component_slot_error)
                    ]),
                    _: 2
                  }, 1032, ["src", "preview-src-list"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "itemName",
                label: "Description",
                "min-width": 10
              }),
              _createVNode(_component_el_table_column, {
                prop: "variantTitle",
                label: "Variant title",
                "min-width": 8
              }),
              _createVNode(_component_el_table_column, {
                prop: "catalogCode",
                label: "Catalog code",
                "min-width": 8
              }),
              _createVNode(_component_el_table_column, {
                prop: "quantity",
                label: "Quantity",
                "min-width": 8
              }),
              _createVNode(_component_el_table_column, {
                prop: "status",
                label: "Status",
                "min-width": 8
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_tag, {
                    type: _ctx.getOrderStatusColor(scope.row.status),
                    size: "small",
                    title: "Order status"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.status), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "Tracking numbers",
                "min-width": 25
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_select, {
                    modelValue: scope.row.trackingNumbers,
                    "onUpdate:modelValue": ($event: any) => ((scope.row.trackingNumbers) = $event),
                    multiple: "",
                    filterable: "",
                    "allow-create": "",
                    clearable: "",
                    "default-first-option": "",
                    "reserve-keyword": false,
                    class: "w-full",
                    placeholder: "Tracking number"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "Carrier",
                "min-width": 25
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_select, {
                    modelValue: scope.row.carriers,
                    "onUpdate:modelValue": ($event: any) => ((scope.row.carriers) = $event),
                    multiple: "",
                    filterable: "",
                    "allow-create": "",
                    clearable: "",
                    "default-first-option": "",
                    "reserve-keyword": false,
                    class: "w-full",
                    placeholder: "Carrier"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _: 1
      }, 512), [
        [_directive_loading, _ctx.idLoading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}